export enum TimesheetSectionNames {
	DAY = 'Day',
	SITE_LOG_HOURS = 'Site Log Hours',
	TIMESHEET_HOURS = 'Timesheet Hours',
	UNPAID_BREAKS = 'Unpaid Breaks',
	NOTES = 'Notes',
}
